import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";

import { push } from "connected-react-router";

import { Button, Input, Layout, Menu } from "antd";

import {
  AlertOutlined,
  BarChartOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  FundProjectionScreenOutlined,
  GlobalOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PlaySquareOutlined,
  ProfileOutlined,
  RobotOutlined,
  SnippetsOutlined
} from "@ant-design/icons";

import logo from "../assets/novarc-logo.white.svg";

import { getRobotsList } from "../features/robot/robotSlice";

const { Sider } = Layout;
const { SubMenu } = Menu;
const { Search } = Input;

const LayoutSider = (props) => {
  const robots = useSelector((state) => state.robot.robots);
  const { isCustomer } = props;
  const { robotName } = useParams();
  const location = useLocation();

  const currentPath = location.pathname + location.hash;

  const [openSider, setOpenSider] = useState(isCustomer ? true : false);

  const [defaultOpenMenu, setDefaultOpenMenu] = useState([robotName]);
  const [defaultSelectedMenu, setDefaultSelectedMenu] = useState(currentPath);
  const [openMenu, setOpenMenu] = useState([robotName]);

  const [searchText, setSearchText] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    if (!robots) {
      dispatch(getRobotsList());
    }
    setDefaultOpenMenu([robotName]);
    setOpenMenu([robotName]);
    setDefaultSelectedMenu(currentPath);
  }, [dispatch, robotName, currentPath, robots]);

  const handleSearch = () => {
    setSearchText(searchText);
  };

  const filterSWR = () => {
    if (searchText === "") {
      return robots;
    } else {
      return robots
        .map((item) =>
          (item.name &&
            item.name
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (item.customer &&
            item.customer
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (item.company &&
            item.company
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (item.location &&
            item.location
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase()))
            ? item
            : null
        )
        .filter((item) => item);
    }
  };

  const logoMenu = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          position: !openSider ? "absolute" : "inherit",
        }}
      >
        <Button
          type="text"
          icon
          onClick={() => {
            setOpenSider(!openSider);
          }}
          style={{ margin: "auto 0px", color: "white" }}
        >
          {React.createElement(
            !openSider ? MenuUnfoldOutlined : MenuFoldOutlined
          )}
        </Button>
        <img
          className="logo"
          alt="logo"
          src={logo}
          style={{ padding: "12px", height: 60, cursor: "pointer" }}
          onClick={() => dispatch(push("/"))}
        />
      </div>
    );
  };

  const menu = (isCustomer) => {
    return filterSWR().map((item) => {
      return (
        <SubMenu
          key={item.name}
          icon={<RobotOutlined />}
          title={item.name}
          onTitleClick={() => {
            const openMenuIndex = openMenu.indexOf(item.name);
            openMenuIndex === -1
              ? setOpenMenu([...openMenu, item.name])
              : openMenu.splice(openMenuIndex, 1);
          }}
        >
          {isCustomer && (
            <>
              <Menu.Item
                key={`/${item.name}/health`}
                icon={<AlertOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/health`));
                }}
              >
                Health
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/analytics`}
                icon={<BarChartOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/analytics`));
                }}
              >
                Analytics
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/weld_test_results`}
                icon={<SnippetsOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/weld_test_results`));
                }}
              >
                Weld Test Results
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/search#videos`}
                icon={<FileSearchOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/search#videos`));
                }}
              >
                Videos
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/search#reports`}
                icon={<FileSearchOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/search#reports`));
                }}
              >
                Daily Report
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/search#novdata_logs`}
                icon={<FileSearchOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/search#novdata_logs`));
                }}
              >
                NovData Logs
              </Menu.Item>
            </>
          )}

          {!isCustomer && (
            <>
              <Menu.Item
                key={`/${item.name}/summary`}
                icon={<ProfileOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/summary`));
                }}
              >
                Summary
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/search`}
                icon={<FileSearchOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/search`));
                }}
              >
                Search Files
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/weld_test_results`}
                icon={<SnippetsOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/weld_test_results`));
                }}
              >
                Weld Test Results
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/videos`}
                icon={<PlaySquareOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/videos`));
                }}
              >
                Video
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/reports`}
                icon={<FilePdfOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/reports`));
                }}
              >
                Daily Report
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/novdata_logs`}
                icon={<FileExcelOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/novdata_logs`));
                }}
              >
                NovData Log
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/noveye_logs`}
                icon={<FileTextOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/noveye_logs`));
                }}
              >
                NovEye Log
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/health`}
                icon={<AlertOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/health`));
                }}
              >
                Health
              </Menu.Item>
              <Menu.Item
                key={`/${item.name}/statistics`}
                icon={<FundProjectionScreenOutlined />}
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(push(`/${item.name}/statistics`));
                }}
              >
                Stats
              </Menu.Item>
            </>
          )}
        </SubMenu>
      );
    });
  };

  if (!openSider) {
    return logoMenu();
  } else {
    return (
      <Sider trigger={null} collapsible collapsed={false}>
        {logoMenu()}
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[defaultSelectedMenu]}
          defaultOpenKeys={defaultOpenMenu}
          selectedKeys={[defaultSelectedMenu]}
          openKeys={openMenu}
        >
          {!isCustomer && (
            <>
              <Menu.Item
                key="/"
                icon={<GlobalOutlined />}
                onClick={() => dispatch(push("/"))}
                style={{ marginBottom: 1 }}
              >
                Overview
              </Menu.Item>
              {/* <Menu.Item key="search" style={{ paddingLeft: 0 }}> */}

              <Search
                placeholder="Search SWR"
                onSearch={() => {
                  handleSearch();
                }}
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
                enterButton
              />
            </>
          )}
          {/* </Menu.Item> */}

          {robots && menu(isCustomer)}
        </Menu>
      </Sider>
    );
  }
};

export default LayoutSider;
